import React, { useState } from 'react';
import PropTypes from 'prop-types';
// import debounce from 'lodash/debounce';
import CommonDropdown from '../../components/common/CommonDropdown';
import { CONTRACT_ADMIN_SEARCH_DROPDOWN_OPTIONS } from '../../constants';
import IconSearch from '../../images/contract-admin-icons/IconSearch';
import IconClose from '../../images/contract-admin-icons/IconClose';

const CASearch = ({
  onChange,
  disableChangeStatus,
  onChangeStatusBtnClicked,
  unableChangeStatusButton = false,
}) => {
  const [value, setValue] = useState('');

  const onInputChange = value => {
    setValue(value);
    onChange(value.trim(), 'searchPhrase');
  };

  const dropdownClickFn = data => {
    onChange(data.value, 'searchBy');
  };

  const resetClickFn = () => {
    setValue('');
    onChange('', 'searchPhrase');
  };

  return (
    <div>
      <div
        className="ca-user-search ca-user-search--horizontal"
        data-test="CASearch"
      >
        <form className="ca-user-search--formWidth">
          <div>
            <div className="user-search--box">
              <div className="user-search--form">
                <div className="ca-user-search--icon">
                  {' '}
                  <span>{!value && <IconSearch />}</span>
                </div>
                <div
                  className="user-search--form-group"
                  data-test="searchQuery"
                >
                  <label className="sr-only" htmlFor="searchQuery" />
                  <input
                    type="text"
                    className="form-control"
                    id="searchQuery"
                    name="searchQuery"
                    placeholder="Search..."
                    autoComplete="off"
                    value={value}
                    onChange={e => onInputChange(e.target.value)}
                  />
                </div>
                <div className="user-searchBy--form-group">
                  <div className="user-searchBy--form-group--text">
                    Search By
                  </div>
                  <div className="user-search--form-group user-search--form-dropdown ca">
                    <CommonDropdown
                      placeHolder="Account"
                      itemClickFn={dropdownClickFn}
                      listData={CONTRACT_ADMIN_SEARCH_DROPDOWN_OPTIONS}
                    />
                  </div>
                </div>
              </div>
              <div
                className="user-search--reset"
                onClick={() => resetClickFn()}
              >
                <span
                  className="user-search--reset--close"
                  onClick={() => resetClickFn()}
                >
                  <IconClose />
                </span>
                <span className="user-search--reset--text">Reset</span>
              </div>
            </div>
          </div>
        </form>
        {unableChangeStatusButton && (
          <div className="ca-user-search--statusChange">
            <button
              type="button"
              disabled={disableChangeStatus}
              className="button ca-change-status"
              data-test="changeStatusBtn"
              onClick={onChangeStatusBtnClicked}
            >
              Change Status
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

CASearch.propTypes = {
  onChange: PropTypes.func,
  disableChangeStatus: PropTypes.bool,
  onChangeStatusBtnClicked: PropTypes.func,
  unableChangeStatusButton: PropTypes.bool,
};

export default CASearch;
